import React from 'react';
import { Sidebar } from '../components/Sidebar';
import { Header } from '../components/Header';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { FilterConfiguration } from './settings/FilterConfiguration';
import { General } from './settings/General';
import { EngagementPlan } from './settings/EngagementPlan';
import { SettingsIcon, FilterIcon, BellIcon, UsersIcon, PlugIcon, ClipboardListIcon } from 'lucide-react';
export function Settings() {
  const location = useLocation();
  const settingsMenuItems = [{
    path: '/settings',
    label: 'General',
    icon: SettingsIcon,
    exact: true
  }, {
    path: '/settings/engagement-plan',
    label: 'Engagement Plan',
    icon: ClipboardListIcon
  }, {
    path: '/settings/filters',
    label: 'Filter Configuration',
    icon: FilterIcon
  }, {
    path: '/settings/notifications',
    label: 'Notifications',
    icon: BellIcon
  }, {
    path: '/settings/users',
    label: 'User Management',
    icon: UsersIcon
  }, {
    path: '/settings/integrations',
    label: 'Integrations',
    icon: PlugIcon
  }];
  const isActive = (path: string, exact?: boolean) => {
    if (exact) {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-2081">
      <Sidebar data-id="element-2082" />
      <main className="flex-1" data-id="element-2083">
        <Header data-id="element-2084" />
        <div className="flex h-[calc(100vh-73px)]" data-id="element-2085">
          {/* Settings Sidebar */}
          <div className="w-64 bg-white border-r border-gray-200 p-4" data-id="element-2086">
            <h2 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-4 px-3" data-id="element-2087">
              Settings
            </h2>
            <nav className="space-y-1" data-id="element-2088">
              {settingsMenuItems.map(item => {
              const Icon = item.icon;
              const active = isActive(item.path, item.exact);
              return <Link key={item.path} to={item.path} className={`flex items-center px-3 py-2 rounded-md text-sm transition-colors ${active ? 'bg-blue-50 text-blue-600 font-medium' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-2089">
                    <Icon size={18} className="mr-3" data-id="element-2090" />
                    {item.label}
                  </Link>;
            })}
            </nav>
          </div>

          {/* Settings Content */}
          <div className="flex-1 overflow-y-auto p-8" data-id="element-2091">
            <Routes data-id="element-2092">
              <Route path="/" element={<General data-id="element-2094" />} data-id="element-2093" />
              <Route path="/engagement-plan" element={<EngagementPlan data-id="element-2096" />} data-id="element-2095" />
              <Route path="/filters" element={<FilterConfiguration data-id="element-2098" />} data-id="element-2097" />
              <Route path="/notifications" element={<NotificationsPlaceholder data-id="element-2100" />} data-id="element-2099" />
              <Route path="/users" element={<UsersPlaceholder data-id="element-2102" />} data-id="element-2101" />
              <Route path="/integrations" element={<IntegrationsPlaceholder data-id="element-2104" />} data-id="element-2103" />
            </Routes>
          </div>
        </div>
      </main>
    </div>;
}
function NotificationsPlaceholder() {
  return <div data-id="element-2105">
      <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-2106">
        Notifications
      </h1>
      <p className="text-gray-600 mb-8" data-id="element-2107">
        Configure your notification preferences
      </p>
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2108">
        <p className="text-gray-500" data-id="element-2109">Notification settings coming soon...</p>
      </div>
    </div>;
}
function UsersPlaceholder() {
  return <div data-id="element-2110">
      <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-2111">
        User Management
      </h1>
      <p className="text-gray-600 mb-8" data-id="element-2112">Manage team members and permissions</p>
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2113">
        <p className="text-gray-500" data-id="element-2114">User management coming soon...</p>
      </div>
    </div>;
}
function IntegrationsPlaceholder() {
  return <div data-id="element-2115">
      <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-2116">
        Integrations
      </h1>
      <p className="text-gray-600 mb-8" data-id="element-2117">
        Connect third-party services and APIs
      </p>
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2118">
        <p className="text-gray-500" data-id="element-2119">Integration settings coming soon...</p>
      </div>
    </div>;
}